// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBoldOutlinedSvg from "@fishx/icons-svg/es/asn/PBoldOutlined";
import FishxIcon from '../components/FishxIcon';

var PBoldOutlined = function PBoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBoldOutlinedSvg
  }));
};

PBoldOutlined.displayName = 'PBoldOutlined';
export default React.forwardRef(PBoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBoldOutlined.js
// module id = 3237
// module chunks = 0